<template>
  <div id="sales-per-sku-skeleton" class="table-list col-12" :data="data" :type="type" :loading="true">
    <table-list-header>
      <table-list-column class-name="col-3 text-left p-0">
        <skeleton-loader width="63px" height="14px" />
      </table-list-column>
      <table-list-column class-name="text-right col-1">
        <skeleton-loader width="42px" height="14px" />
      </table-list-column>
      <table-list-column class-name="text-right col-2">
        <skeleton-loader width="85px" height="14px" />
      </table-list-column>
      <table-list-column class-name="text-right col-2">
        <skeleton-loader width="125px" height="14px" />
      </table-list-column>
      <table-list-column class-name="text-right col-2">
        <skeleton-loader width="86px" height="14px" />
      </table-list-column>
      <table-list-column class-name="text-right col-2">
        <skeleton-loader width="123px" height="14px" />
      </table-list-column>
    </table-list-header>
    <table-list-body>
      <table-list-row v-for="row in rows" :key="row">
        <table-list-column class-name="text-left col-3 pl-0 pr-0">
          <skeleton-loader width="95px" height="14px" />
        </table-list-column>
        <table-list-column class-name="text-right col-1">
          <skeleton-loader width="68px" height="14px" />
        </table-list-column>
        <table-list-column class-name="text-right col-2">
          <skeleton-loader width="40px" height="14px" />
        </table-list-column>
        <table-list-column class-name="text-right col-2">
          <skeleton-loader width="20px" height="14px" />
        </table-list-column>
        <table-list-column class-name="text-right col-2">
          <skeleton-loader width="62px" height="14px" />
        </table-list-column>
        <table-list-column class-name="text-right col-2">
          <skeleton-loader width="95px" height="14px" />
        </table-list-column>
      </table-list-row>
    </table-list-body>
  </div>
</template>

<script>
import SkeletonLoader from '@/components/_atoms/SkeletonLoader';

export default {
  components: {
    'skeleton-loader': SkeletonLoader,
  },
  props: {
    data: {
      type: Object,
      default: () => {},
    },
    type: {
      type: String,
      default: '',
    },
  },
  computed: {
    rows() {
      const length = this.data.limit;
      const arr = new Array(length);

      for (let i = 0; i < length; i += 1) {
        arr[i] = (i + 1).toString();
      }
      return arr;
    },
  },
};
</script>

<style lang="scss" scoped>
.header {
  margin: 40px 0 25px;
}
</style>
